import React, { useState, useMemo } from 'react';
import { ConfirmationDialog } from '../../components/ConfirmationDialog/ConfirmationDialog';
import {
  OverflowMenu,
  OverflowMenuGroup,
  MENU_ICONS as ICONS,
} from '../../components/MenuOptions/OverflowMenu';

interface Props {
  actions?: {
    onEdit?: () => void;
    onDelete?: () => void;
  };
}

// Same options, order, and labels as the v2 product menu
// (productsV2/productListView/ProductMenu.tsx): Settings, Delete. Viewing a
// product is the card click, not a menu item. SKUs live in the Settings
// modal's SKUs tab.
export const ProductMenu: React.FC<Props> = ({ actions }) => {
  const [showDelConfirmationDialog, setShowDelConfirmationDialog] = useState(false);

  const groups = useMemo((): OverflowMenuGroup[] => {
    if (!actions) return [];

    const edit: OverflowMenuGroup = { label: 'Edit', items: [] };
    if (actions.onEdit) {
      edit.items.push({ key: 'settings', label: 'Settings', icon: ICONS.settings, onClick: actions.onEdit });
    }

    const danger: OverflowMenuGroup = { label: '', items: [] };
    if (actions.onDelete) {
      danger.items.push({
        key: 'delete',
        label: 'Delete',
        icon: ICONS.trash,
        danger: true,
        onClick: () => setShowDelConfirmationDialog(true),
      });
    }

    return [edit, danger];
  }, [actions]);

  if (!actions) return null;

  return (
    <>
      <OverflowMenu groups={groups} ariaLabel="Product actions" width={230} />

      <ConfirmationDialog
        open={showDelConfirmationDialog}
        onClose={() => setShowDelConfirmationDialog(false)}
        onConfirm={() => {
          actions.onDelete?.();
          setShowDelConfirmationDialog(false);
        }}
        title='Delete Product'
        description='Are you sure you want to delete this product? This action is irreversible.'
        confirmLabel='Delete'
        cancelLabel='Cancel'
      />
    </>
  );
};
